export enum ESortOption {
  Default = 'NEXT_LUNCH_PLAN',
  DistanceMinutes = 'DISTANCE_MINUTES',
  Name = 'NAME',
}
